export const monthsHeb = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];

export class MOBILITY_LOGO {
	static get SHANATOVA() {
		return MOBILITY_LOGO_SHANATOVA;
	}
	static get PESACH() {
		return MOBILITY_LOGO_PESACH;
	}
	static get HANNUKAH() {
		return '/assets/images/logo-hannukah.svg';
	}
	static get DEFAULT() {
		return '/assets/images/logo.svg';
	}
}

const MOBILITY_LOGO_SHANATOVA = '/assets/images/logo_ShanaTova.svg';

const MOBILITY_LOGO_PESACH = '/assets/images/logo_Passover2022.svg';

export const ccExpiryMonths = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, '0'));
export const ccExpiryYears = Array.from({ length: 10 }, (_, i) => (new Date().getFullYear() + i).toString().slice(-2));

// utilities
/**
 * @description The maximum value of a 32-bit signed integer (2,147,483,647)
 */
export const MAX_INT32 = 2 ** 31 - 1;

export enum Time {
	minuteInMilliseconds = 60000, // 1000 * 60
	hour = minuteInMilliseconds * 60,
	day = hour * 24,
	week = day * 7,
}
